module.exports = __webpack_public_path__ + "static/media/P1000864.d6f354aa.jpg";